import { Component } from '@angular/core';

@Component({
  selector: 'app-cards1-examples-3',
  templateUrl: './cards1-examples-3.component.html'
})
export class Cards1Examples3Component {}
